import React from 'react';
import { withRouter } from 'react-router-dom';
import Suspense from '../../Common/components/Suspense-component';

import { getNationalHolidays, getSinglePharmacy } from '../epics-pharmacies';
import { prepareHolidays } from '../../Common/Helpers';
import EditPharmacy from '../component-edit-pharmacy';
import { UserRole } from '../../Common/UserRole';
import { getCompaniesReducedList } from '../../Companies/epics-companies';
import localStorage from '../../Common/LocalStorage';
import { getCompanyOfUser, getFreeUsersForPharmacyManager } from '../../Users/epics-users';

class EditPharmacyPage extends React.Component {
    getPharmacyDetails = () => {
        return getSinglePharmacy(this.props.match.params.pharmacyId);
    };

    generateCompanyList = () => {
        switch (localStorage.getUsernameRole()) {
            case UserRole.ADMIN:
                return getCompaniesReducedList();
            case UserRole.STORE_OWNER:
                return getCompanyOfUser();
            case UserRole.PHARMACY_MANAGER:
                return getCompanyOfUser();
            default:
                return [];
        }
    };

    getUsersForPharmacyManager = (identifier, companyId, pharmacyId) => {
        return getFreeUsersForPharmacyManager(identifier, companyId, pharmacyId);
    };

    getNationalHolidays = () => {
        return getNationalHolidays().then(response => {
            return prepareHolidays(response);
        });
    };

    render() {
        return (
            <Suspense
                apiCalls={{
                    selectedPharmacy: this.getPharmacyDetails,
                    companyList: this.generateCompanyList,
                    pharmacyManagerList: this.getUsersForPharmacyManager,
                    nationalHolidays: this.getNationalHolidays   
                }}
                
            >
                <EditPharmacy />
            </Suspense>
        );
    }
}

export default withRouter(EditPharmacyPage);



// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/containers/container-edit-pharmacy.js